import { render, staticRenderFns } from "./Virus.vue?vue&type=template&id=10bade92&scoped=true&"
import script from "./Virus.vue?vue&type=script&lang=ts&"
export * from "./Virus.vue?vue&type=script&lang=ts&"
import style0 from "./Virus.vue?vue&type=style&index=0&id=10bade92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bade92",
  null
  
)

export default component.exports